import { injectable } from "inversify";
import { makeAutoObservable, runInAction } from "mobx";
import { EventHandler, IRemainingTime, TimerEvent } from "@/lib/types/training";
import { formatMmSs } from "@/lib/utils/format-time";

const SESSION_DURATION = 4 * 60 * 1000; //10m

@injectable()
export class RemainingTime implements IRemainingTime {
  remainingTime = SESSION_DURATION;
  private startTime = Date.now();
  private interval: ReturnType<typeof setInterval> | null = null;
  private handlers: Record<TimerEvent, EventHandler[]> = {
    start: [],
    end: [],
  };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  private dispatchEvent(ev: TimerEvent) {
    this.handlers[ev].forEach((cb) => cb());
  }
  on(ev: TimerEvent, cb: EventHandler) {
    this.handlers[ev].push(cb);
  }
  off(ev: TimerEvent, cb: EventHandler) {
    this.handlers[ev] = this.handlers[ev].filter((h) => h !== cb);
  }

  startTimer() {
    this.startTime = Date.now();
    this.dispatchEvent("start");
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      const remainingTime = SESSION_DURATION - (Date.now() - this.startTime);
      if (remainingTime <= 0) {
        // stopTimer() already resets remainingTime — writing the stale
        // negative value afterwards would immediately clobber that reset.
        this.stopTimer();
        return;
      }
      runInAction(() => {
        this.remainingTime = remainingTime;
      });
    }, 300);
  }
  stopTimer() {
    this.dispatchEvent("end");
    this.startTime = Date.now();
    this.remainingTime = SESSION_DURATION;
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  get displayTime() {
    return formatMmSs(this.remainingTime);
  }
  dispose() {
    this.stopTimer();
  }
}
